import { SupervisedQueue } from "@/repository/models";

export enum DesireType {
    High = 1,
    Normal = 2,
    Low = 3,
}

export interface DesireMenuProps {
    data: SupervisedQueue;
    onChange: (data: SupervisedQueue, desire: DesireType) => void;
}
